import { RouteButton } from "@/components/common/styles";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import NotificationItem, {
  NotificationItemComponent,
} from "./NotificationItem";

const QuestionIsAddedNotification: NotificationItemComponent = ({ item }) => {
  return (
    <NotificationItem variant={!item.dismissed_at ? "warning" : "default"}>
      <NotificationItem.Title created_at={item.created_at}>
        Additional Information Required
      </NotificationItem.Title>
      <NotificationItem.Content>
        We need additional information to complete the verification.
      </NotificationItem.Content>
      <NotificationItem.Actions {...item}>
        <RouteButton
          size="small"
          variant={!item.dismissed_at ? "contained" : "outlined"}
          color={!item.dismissed_at ? "warning" : "primary"}
          disableElevation
          endIcon={<OpenInNewIcon fontSize="small" />}
          to="/accountverification"
        >
          View Verification
        </RouteButton>
      </NotificationItem.Actions>
    </NotificationItem>
  );
};
export default QuestionIsAddedNotification;
